
import { NgProgress } from 'ngx-progressbar';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import {
    Component,
    OnInit,
    ViewChild,
    ViewContainerRef,
    OnDestroy,
    ElementRef
} from '@angular/core';
import { MarketingService } from '../services/marketing.service';
import { Promotion } from '../models/marketing.model';
import { NgModel} from '@angular/forms';
import { CommonService } from '../services';
import { NgProgressService } from '../services/ngProgress.service';
import { AuthService } from '../services/auth.service';
import { CurrentUserModel } from '../models/account-ledger.model';

@Component({
    selector: 'app-microsites',
    templateUrl: './microsites.component.html',
    styleUrls: ['./microsites.component.css']
})

export class MicrositesComponent implements OnInit {
    title = 'Microsites';
    type = 'M';
    analyticsTypeId = 2;
    micrositeList: Array<Promotion>;
    selectedMicrositeList = new Array<Promotion>();
    featuredMicrosites = new Array<Promotion>();
    promotionsBrands = [];
    selectedBrands = [];
    @ViewChild('brandSelect') private brandSelect: NgModel;
    @ViewChild("ParentWrapper", { static: true }) parentWrapper: ElementRef;

    searchField = '';
    loadContent = false;
    currentUserModel: CurrentUserModel;
    isAU: boolean;
  
    constructor(
        private activeRouter: ActivatedRoute,
        private marketingService: MarketingService,
        private ngProgress: NgProgressService,
        private router: Router,
        private commonService: CommonService,
        private authService: AuthService
    ) {
    }

    navigateTo(url: string) {
        this.router.navigate([url]);
    }

    ngOnInit() {
        this.ngProgress.start();
        
        this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
            this.currentUserModel = res;
            this.isAU = this.currentUserModel.isAU;
          },
            (error: any) => {
              console.info(error);
            });

        this.micrositeList = new Array<Promotion>();
        this.activeRouter.url.subscribe(value => {
            if (value.length === 0) {
                $('.page-contents').animate({ scrollLeft: 0 }, 400);
            }
            this.marketingService.getPromotionList(this.type).subscribe((value: Array<Promotion>) => {
                this.micrositeList = value;
                this.selectedMicrositeList = value;
                if(this.micrositeList && this.micrositeList.length > 0){
                    this.promotionsBrands = this.micrositeList.map(data => data.brand).sort();
                    this.selectedMicrositeList.forEach(item => {
                        if (item.brand === null) {
                            item.brand = '';
                        }
                        if (item.title === null) {
                            item.title = '';
                        }
                        if (item.description === null) {
                            item.description = '';
                        }
                        if (!item.promotionLink.toLowerCase().includes('http')) {
                            item.promotionLink = 'http://' + item.promotionLink;
                        }
                    })
                    this.featuredMicrosites = this.micrositeList.filter(data => data.topSpot);
                    this.commonService.applyScrollFixedHeader(this.parentWrapper);
                }
                
            },
            (error: any) => {
                console.info(error);
                this.ngProgress.done();
            });
        });

        this.ngProgress.done();
    }

    updateBrandList(event) {
        var selectedBrands = event.value;
        if (selectedBrands && selectedBrands.length > 0) {
            this.selectedMicrositeList = [];
            selectedBrands.forEach(sb => {
                this.micrositeList.filter(pl => pl.brand.toLowerCase() == sb.toLowerCase()).forEach(fi => {
                    this.selectedMicrositeList.push(fi);
                })
            })
        }
        else
            this.selectedMicrositeList = this.micrositeList;
    }

    filterMicrositeList() {
        if (this.searchField.length > 0 && this.searchField.length < 2) {
            return;
        }
        else if (this.searchField.length == 0) {
            this.selectedMicrositeList = this.micrositeList;
        }
        else {
            var search = this.searchField.toLocaleLowerCase();
            var result = this.selectedMicrositeList.filter((v, i) => {
                return (v.brand.toLocaleLowerCase().includes(search) 
                    || v.title.toLocaleLowerCase().includes(search) 
                    || v.description.toLocaleLowerCase().includes(search));
            })
            this.selectedMicrositeList = result;
        }
    }

    onLoading(currentLoadingStatus: boolean) {
        this.loadContent = !currentLoadingStatus;
    }

    clearFilters(){
        this.searchField = "";
        this.brandSelect.update.emit([]);
        this.selectedBrands.length = 0;
        this.selectedMicrositeList = this.micrositeList;
    }

    onNavigate(id, url) {
        console.log("clicked")
        this.marketingService.UpdateAnalytics( this.analyticsTypeId, id, this.commonService.analyticsClick).subscribe(value => {
            //success or error
            });
        window.open(url, '_blank');
    }

}
